import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';
import RenderTooltipCellByTypeView from '../../../shared/components/RenderTooltipCell';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.name}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('general.active'), field: 'activeDescription' },
    {
      title: t('general.year-level'),
      field: 'courseStep.fullName',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.courseStep.fullName}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('general.order'), field: 'schoolGrade.order' },
    { title: t('general.term'), field: 'term.name' },
    { title: t('general.year'), field: 'term.year' },
    { title: t('general.capacity'), field: 'capacity' },
    { title: t('general.occupation'), field: 'studentsQuantity' },
    { title: t('general.availability'), field: 'availability' },
  ];
}
